(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ResultRangeDialogController', ResultRangeDialogController);

    ResultRangeDialogController.$inject = ['$timeout', '$scope', 'Compendium', '$uibModalInstance', 'resultRange', 'ResultRange'];

    function ResultRangeDialogController ($timeout, $scope, Compendium, $uibModalInstance, resultRange, ResultRange) {
        var vm = this;

        vm.resultRange = resultRange;
        vm.clear = clear;
        vm.save = save;

        vm.compendiums = Compendium.by_clinic_result_range_dif({id: vm.resultRange.clinic.id});

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.resultRange.id !== null) {
                ResultRange.update(vm.resultRange, onSaveSuccess, onSaveError);
            } else {
                ResultRange.save(vm.resultRange, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:resultRangeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
